import React from 'react';
import { Grid, Image } from 'semantic-ui-react';
import SearchInputComponent from '../search/SearchInputComponent';

export default class MainContainer extends React.Component {
    render() {
        return (
            <div>
                <Grid centered columns={1}>
                    <Grid.Row>
                        <Image size="medium" src='/images/logo_large.png' />
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column computer={6} mobile={14} tablet={6}>
                            <SearchInputComponent />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/main/MainContainer.js